/**
 * Every Gateway path this module calls.
 *
 * Collected here so a route change is one edit, and so a reader can see the
 * module's entire surface against the platform without grepping for string
 * literals in JSX.
 */
export const paymentPolicyEndpoints = {
  list: '/v1/payment-policies',
  create: '/v1/payment-policies',
  options: '/v1/payment-policies/options',
  detail: (policyId: string) => `/v1/payment-policies/${policyId}`,
  update: (policyId: string) => `/v1/payment-policies/${policyId}`,
  delete: (policyId: string) => `/v1/payment-policies/${policyId}`,
} as const;
